module.exports = __webpack_public_path__ + "img/pick_3.20c5b5af.png";